import {
  AAddNursingStations,
  AAddUnitDetails,
  AAddPatronDetails,
  UpdateMealFilter,
  UpdateRoomFilter,
  AAddPatronTrayDetails,
} from './../../data/actions/units.action';
import { Store } from '@ngxs/store';
import { UnitsService } from './../../services/units.service';
import { Injectable } from '@angular/core';
import {
  IUnitsFilters,
  IUnitsFiltersItem,
} from 'src/app/models/units/units-utilities.model';
import { IUnitsDetailsGrouped } from '../../models/units/units-utilities.model';
import { INursingStation } from '../../models/service/nursing-stations.model';
import { IUnitDetails } from 'src/app/models/service/units-details.model';
import { IMeals } from '../../models/service/meals.model';
import { ServiceTicketI } from '../../models/service/serviceTicket.model';

@Injectable({ providedIn: 'root' })
export class UnitsReducer {
  // TODO: SEE IF WE CAN CONVERT THIS INTO AN ADAPTER
  constructor(private unitsService: UnitsService, private store: Store) {}
  public async getNursingStations(): Promise<void> {
    const nssResponse = await this.unitsService
      .getNursingStations()
      .then(res => res)
      .catch(() => null);
    if (!!nssResponse) {
      if (nssResponse.data.length > 0) {
        this.store.dispatch(new AAddNursingStations(nssResponse.data));
      }
    }
  }

  public async getNursingStationsAndUnitsDetails(): Promise<void> {
    const nssResponse = await this.unitsService
      .getNursingStations()
      .then(res => res)
      .catch(() => null);
    if (!!nssResponse) {
      if (nssResponse.data.length > 0) {
        this.store.dispatch(new AAddNursingStations(nssResponse.data));
        nssResponse.data.sort((a: INursingStation, b: INursingStation) => {
          if (a.Name < b.Name) {
            return -1;
          }
          if (a.Name > b.Name) {
            return 1;
          }
          return 0;
        });
        await this.getUnitById(nssResponse.data[0].Oid, true);
      }
    }
  }

  public async getPatronDetails(
    admissionId: number,
    trayId: string,
    isPHIShown: boolean,
    unitDetail: IUnitDetails,
  ): Promise<void> {
    const patronDetailsResponse = await this.unitsService
      .getPatronDetails(admissionId, isPHIShown)
      .catch(() => null);
    if (!!patronDetailsResponse) {
      const patronTrayDetailsResponse = await this.unitsService
        .getPatronTrayDetails(admissionId, trayId, unitDetail)
        .catch(() => null);
      if (!!patronTrayDetailsResponse) {
        this.store.dispatch(
          new AAddPatronDetails(patronDetailsResponse.data[0]),
        );
        this.store.dispatch(
          new AAddPatronTrayDetails(patronTrayDetailsResponse),
        );
      }
    }
  }

  public async getUnitById(
    unitId: number,
    saveState = true,
  ): Promise<IUnitsDetailsGrouped[]> {
    const unitsResponse: IUnitDetails[] = await this.unitsService
      .getUnitById(unitId)
      .catch(() => null);
    const unitsDetailsGrouped: IUnitsDetailsGrouped[] = [];
    if (!!unitsResponse) {
      if (unitsResponse?.length > 0) {
        unitsResponse.forEach(unitsDetail => {
          if (unitsDetail.patronType) {
            const roomIndex = unitsDetailsGrouped.findIndex(
              room => room.admitRoomId === unitsDetail.admitRoomId,
            );
            if (roomIndex >= 0) {
              unitsDetailsGrouped[roomIndex].unitsDetails.push(unitsDetail);
            } else {
              unitsDetailsGrouped.push({
                admitRoomId: unitsDetail.admitRoomId,
                admitRoomName: unitsDetail.admitRoomName,
                unitsDetails: [unitsDetail],
              });
            }
          }
        });
      }
      if (saveState) {
        this.saveUnitDetails(unitsDetailsGrouped);
      }
      return unitsDetailsGrouped;
    }
  }

  public saveUnitDetails(units: IUnitsDetailsGrouped[]): void {
    this.store.dispatch(new AAddUnitDetails(units));
  }

  public async updateFilters(filters: IUnitsFilters): Promise<void> {
    this.store.dispatch(new UpdateRoomFilter(filters));
  }

  public async getMeals(): Promise<void> {
    const allMeals: IUnitsFiltersItem[] = [];
    const mealsResponse: IMeals[] = await this.unitsService
      .getMeals()
      .catch(() => null);
    const validMealTypes: string[] = ['MainMeal', 'Nourishment'];
    if (!!mealsResponse) {
      mealsResponse.sort((a: IMeals, b: IMeals) => {
        if (a.sortOrder > b.sortOrder) {
          return 1;
        }
        if (a.sortOrder < b.sortOrder) {
          return -1;
        }
        return 0;
      });

      for (const meal of mealsResponse.filter(
        m =>
          m.orderCutoffTime !== null &&
          validMealTypes.includes(m.timePeriodMealType),
      )) {
        const mealExists = allMeals.find(m => m.name === meal.name);
        if (!mealExists) {
          allMeals.push({
            name: meal.name,
            checked: false,
          });
        }
      }
      this.store.dispatch(new UpdateMealFilter(allMeals));
    }
  }

  public async getServiceTicketDetails(
    trayOid: number,
  ): Promise<ServiceTicketI> {
    const serviceTicket = await this.unitsService
      .getServiceTickets(trayOid)
      .catch(() => null);
    return serviceTicket.data[0];
  }
}
